import { render, staticRenderFns } from "./CuidadoPaciente.vue?vue&type=template&id=7442816e&"
import script from "./CuidadoPaciente.vue?vue&type=script&lang=js&"
export * from "./CuidadoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports